/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCSVRowsFromJSON, ApiCSVRowsToJSON, } from './ApiCSVRows';
import { ApiCSVUploadSessionStatusFromJSON, ApiCSVUploadSessionStatusToJSON, } from './ApiCSVUploadSessionStatus';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiCSVUploadSessionFromJSON(json) {
    return ApiCSVUploadSessionFromJSONTyped(json, false);
}
export function ApiCSVUploadSessionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'csvRule': !exists(json, 'csvRule') ? undefined : json['csvRule'],
        'err': !exists(json, 'err') ? undefined : json['err'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'key': !exists(json, 'key') ? undefined : json['key'],
        'msg': !exists(json, 'msg') ? undefined : json['msg'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'rows': !exists(json, 'rows') ? undefined : (json['rows'].map(ApiCSVRowsFromJSON)),
        'status': !exists(json, 'status') ? undefined : ApiCSVUploadSessionStatusFromJSON(json['status']),
    };
}
export function ApiCSVUploadSessionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'csvRule': value.csvRule,
        'err': value.err,
        'id': value.id,
        'key': value.key,
        'msg': value.msg,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'rows': value.rows === undefined ? undefined : (value.rows.map(ApiCSVRowsToJSON)),
        'status': ApiCSVUploadSessionStatusToJSON(value.status),
    };
}
